import React, { Fragment } from "react"
import { Card } from 'primereact/card';
import "./cardStyle.css"
import PropTypes from 'prop-types';

function CardComp({ title, children,...rest }) {
    return (<Card title={title} {...rest}>
          {children}
        </Card>
    )
}

CardComp.propTypes = {
    title: PropTypes.string,
    children:PropTypes.object,
}
export default CardComp;